$.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

const lang = $('html').attr('lang');

const $form = $('form#phase-4');
let selectedCount = $('[name="input_table_proximity[]"]:checked').length;

$body.on('click', '[name="input_table_proximity[]"]', function(e) {
    $input = $(this);

    if($input.is(':checked')) {
        selectedCount = selectedCount + 1;
        $form.append('<input type="hidden" name="table_proximity[]" value="'+$input.val()+'" />');
    } else {
        selectedCount = selectedCount - 1;
        $form.find('input[type="hidden"][value="'+$input.val()+'"]').remove();
    }

    if (selectedCount > 5) {
        $input.prop('checked', false);
        selectedCount--;
        $form.find('input[type="hidden"][value="'+$input.val()+'"]').remove();
        TweenLite.set('.modal-alert-partner', { display: 'flex', opacity: 0 });
        TweenLite.to('.modal-alert-partner', .4, { opacity: 1 });
    }
});

const datatables_ptbr = {
    "sEmptyTable": "Nenhum registro para exibir",
    "sInfo": "_START_ até _END_ de _TOTAL_ registros",
    "sInfoEmpty": "0 registros",
    "sInfoFiltered": "(Filtrados de _MAX_ registros)",
    "sInfoPostFix": "",
    "sInfoThousands": ".",
    "sLengthMenu": "Mostrar _MENU_ por página",
    "sLoadingRecords": "Carregando...",
    "sProcessing": "Processando...",
    "sZeroRecords": "Não encontramos nenhum resultado para essa busca.",
    "sSearch": "Buscar",
    "oPaginate": {
        "sNext": "Próximo",
        "sPrevious": "Anterior",
        "sFirst": "Primeiro",
        "sLast": "Último"
    },
    "oAria": {
        "sSortAscending": ": Ordenar colunas de forma ascendente",
        "sSortDescending": ": Ordenar colunas de forma descendente"
    }
};

const datatables_en = {
    "sEmptyTable": "No entries",
    "sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
    "sInfoEmpty": "0 entries",
    "sInfoFiltered": "(Filtered from _MAX_ total entries)",
    "sInfoPostFix": "",
    "sInfoThousands": ".",
    "sLengthMenu": "Show _MENU_ per page",
    "sLoadingRecords": "Loading...",
    "sProcessing": "Processing...",
    "sZeroRecords": "We didn't find any resoluts for this search.",
    "sSearch": "Search",
    "oPaginate": {
        "sNext": "Next",
        "sPrevious": "Previous",
        "sFirst": "First",
        "sLast": "Last"
    },
    "oAria": {
        "sSortAscending": ": Ordenar colunas de forma ascendente",
        "sSortDescending": ": Ordenar colunas de forma descendente"
    }
};

const columns = [
    {
        data: 'table',
        name: 'table',
        title: lang == 'pt' ? 'Nome do Artista' : 'Artist\'s Name',
        searchable: true,
        orderable: true,
        width: '40%',
    },
    {
        data: 'jobs',
        name: 'jobs',
        title: lang == 'pt' ? 'Gênero de trabalho' : 'Work genre',
        searchable: true,
        orderable: true,
        width: '45%',
    },
];

const $tableProximity = $('#table-proximity').DataTable({
    sDom: 'lrtip',
    orderCellsTop: true,
    fixedHeader: true,
    oLanguage : lang == 'pt' ? datatables_ptbr : datatables_en,
    order: [[0, "asc"]],
    pageLength: 5,
    columns: columns,
    stateSave: true,
    scrollX: false,
    initComplete: function (settings, json) {

        var api = new $.fn.dataTable.Api(settings);
        var state = api.state.loaded();

        $(this).find('thead').append('<tr role="row" class="filters"></tr>');

        this.api().columns().every(function(colIndex) {

            var th = $('<th></th>').appendTo($('tr.filters'));
            var column = this;
            var column_name = column.dataSrc();


            if(column_name == 'table') {
                $('<input type="text" class="form-control form-control-sm" placeholder="'+(lang == 'pt' ? 'Buscar' : 'Search')+'" value="'+(state ? state.columns[colIndex].search.search : '')+'" />')
                        .appendTo(th)
                        .on('keyup', function() {

                            if($(this).val() == '') {
                                $(this).removeClass('has-value');
                            } else {
                                $(this).addClass('has-value');
                            }

                            column.search($(this).val(), false, true).draw();

                        });
            }

            if(column_name == 'jobs') {
                var select = $('<select class="form-control form-control-sm"><option value="" selected>'+(lang == 'pt' ? 'Todos' : 'All')+'</option></select>');
                $.each(job_class_items, function(i, e) {
                    let titleLang = lang == 'pt' ? e.replace('. Qual?', '') : e.replace('. Wich one?', '');
                    select.append('<option value="'+titleLang+'" '+(state && state.columns[colIndex].search.search == titleLang ? 'selected' : '')+'>'+titleLang+'</option>');
                });
                select.appendTo(th).on('change', function() {
                    if($(this).val() == '') {
                        $(this).removeClass('has-value');
                    } else {
                        $(this).addClass('has-value');
                    }

                    column.search($(this).val()).draw();
                });
            }
        });
    }
});

$(document).on('click', '.btn-save-draft', function(e) {
    let $form = $('form.form-default');
    $form.find('[name="action"]').val('draft');
});

function closeModal () {
    $('.modal').fadeOut();
}

$('.modal').on('click', function(e) {
    if ($(e.target).closest('.modal-content').length == 0) {
        closeModal();
    }
});

$('.modal button').on('click', function() {
    closeModal();
});

$(document).keyup(function(e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
        closeModal();
    }
});

if ($('.is-invalid, .invalid-feedback, .error').length) {
    var y = $('.is-invalid, .invalid-feedback, .error').eq(0).parents('.form-group').offset().top - $('header').height() - 10;
    window.scrollTo({
        top: y,
    });
}
